import type { Conversation } from '@twilio/conversations';

import { ConversationChatView } from '../ChatScreen/ConversationChatView';

type ArchivedConversationContentProps = {
  conversation: Conversation | null;
  inlineTitle?: string;
};

const ArchivedConversationContent = ({
  conversation,
  inlineTitle,
}: ArchivedConversationContentProps) => (
  <ConversationChatView
    conversation={conversation}
    emptyMessage={'This archived chat is unavailable.'}
    inlineTitle={inlineTitle}
    readOnly={true}
  />
);

export { ArchivedConversationContent };
